import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-receipt-detail',
  templateUrl: './receipt-detail.component.html',
  styleUrls: ['./receipt-detail.component.css']
})
export class ReceiptDetailComponent implements OnInit {

  type = '';
  no = '';
  title = '';
  public menu_item_id = '32';
  public add_auth;
  public edit_auth;
  public del_auth;

  route_list = [];
  button_list = [];
  top_part = [];
  bottom_part = [];
  receipt_detail = { 'comment': '' };
  // comment;
  dp = [];

  displayedColumns = ['invoice_no', 'total', 'invoice_date', 'paid_amount', 'remain_amount'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  Success_Msg; Error_Msg; Del_Msg; With_Amount; Receipt_Type; Cash_Receipt;
  Payment_Voucher; Acct; Acct_Type; Number; Date; Receipt_No; Amount; From;
  To; Cost_Center; Pay_Method; Account; Check_No; Receipt_Detail; Statement_Detail;

  constructor(private route: ActivatedRoute, private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private router: Router, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Receipt_Detail').subscribe((res: string) => {
      this.Receipt_Detail = res;
    });

    translate.get('Statement_Detail').subscribe((res: string) => {
      this.Statement_Detail = res;
    });

    translate.get('With_Amount').subscribe((res: string) => {
      this.With_Amount = res;
    });

    translate.get('Acct').subscribe((res: string) => {
      this.Acct = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Acct_Type').subscribe((res: string) => {
      this.Acct_Type = res;
    });

    translate.get('Date').subscribe((res: string) => {
      this.Date = res;
    });

    translate.get('Cash_Receipt').subscribe((res: string) => {
      this.Cash_Receipt = res;
    });

    translate.get('Payment_Voucher').subscribe((res: string) => {
      this.Payment_Voucher = res;
    });

    translate.get('Number').subscribe((res: string) => {
      this.Number = res;
    });

    translate.get('Receipt_No').subscribe((res: string) => {
      this.Receipt_No = res;
    });

    translate.get('Amount').subscribe((res: string) => {
      this.Amount = res;
    });

    translate.get('From').subscribe((res: string) => {
      this.From = res;
    });

    translate.get('To').subscribe((res: string) => {
      this.To = res;
    });

    translate.get('Cost_Center').subscribe((res: string) => {
      this.Cost_Center = res;
    });

    translate.get('Pay_Method').subscribe((res: string) => {
      this.Pay_Method = res;
    });

    translate.get('Receipt_Type').subscribe((res: string) => {
      this.Receipt_Type = res;
    });

    translate.get('Account').subscribe((res: string) => {
      this.Account = res;
    });

    translate.get('Check_No').subscribe((res: string) => {
      this.Check_No = res;
    });
  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    this.route.params.subscribe(params => {
      this.type = params['type'];
      this.no = params['no'];
      this.title = (this.type == 'receipt_statement' ? this.Statement_Detail : this.Receipt_Detail);

      this.route_list = [
        {
          'button_name': 'عودة للقائمة', 'button_name_en': 'Back to List',
          'router_link': (this.type == 'receipt_statement' ? '../../../statement_list' : '../../../receipt_list')
        }];

      // if (this.edit_auth)
      //   this.route_list.push({
      //     'button_name': ' تعديل ' + (this.type == 'receipt_statement' ? 'الإيصال' : 'السند'),
      //     'button_name_en': 'Edit Receipt',
      //     'router_link': (this.type == 'receipt_statement' ? '../../../receipt_statement/' + this.no : '../../../receipt/' + this.no + '/' + this.type)
      //   });

      this.button_list = [{
        'button_name': 'طباعة ' + (this.type == 'receipt_statement' ? 'الإيصال' : 'السند'),
        'button_name_en': 'Print Receipt', 'op_type': 'print'
      }];


      let obj = { cmd: 'getReceiptDetail', type: this.type, no: this.no };
      this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();

          this.receipt_detail = data.status['msg'];
          if (this.receipt_detail['receipt_type'] == 'simple') {
            if (this.edit_auth && this.receipt_detail['is_locked'] == '0')
              this.route_list.push({
                'button_name': ' تعديل ' + (this.type == 'receipt_statement' ? 'الإيصال' : 'السند'),
                'button_name_en': 'Edit Receipt',
                'router_link': (this.type == 'receipt_statement' ? '../../../receipt_statement/' + this.no : '../../../simple_receipt/' + this.no + '/' + this.type)
              });
          }
          else {
            if (this.edit_auth && this.receipt_detail['is_locked'] == '0')
              this.route_list.push({
                'button_name': ' تعديل ' + (this.type == 'receipt_statement' ? 'الإيصال' : 'السند'),
                'button_name_en': 'Edit Receipt',
                'router_link': (this.type == 'receipt_statement' ? '../../../receipt_statement/' + this.no : '../../../receipt/' + this.no + '/' + this.type)
              });
          }

          if (this.del_auth && this.receipt_detail['is_locked'] == '0')
            this.button_list.push({
              'button_name': 'حذف ' + (this.type == 'receipt_statement' ? 'الإيصال' : 'السند'),
              'button_name_en': 'Delete Receipt', 'op_type': 'delete'
            });

          this.fillTable(this.receipt_detail);
          console.log(this.receipt_detail);
        });
    });

  }

  fillTable(detail) {

    let acct_name1 = '';
    if (detail['acct_list1'].length > 0) {
      detail['acct_list1'].forEach(element => {
        if (acct_name1 != '')
          acct_name1 += ' - ';

        acct_name1 += element.acct_name + " (" + element.acct_number + ")  " + this.With_Amount + ": " +
          element.amount;
      });
    }
    else
      acct_name1 = detail['acct_name'] + " (" + detail['acct_number'] + ")";

    let acct_name2 = '';
    if (detail['acct_list2'].length > 0) {
      detail['acct_list2'].forEach(element => {
        if (acct_name2 != '')
          acct_name2 += ' - ';

        acct_name2 += element.acct_name + " (" + element.acct_number + ")  " + this.With_Amount + ": " +
          element.amount;
      });
    }
    else
      acct_name2 = (this.type != 'payment_voucher' ? detail['to_acct_name'] + " (" + detail['to_acct'] + ")" :
        detail['from_acct_name'] + " (" + detail['from_acct'] + ")");

    let rowObj;
    if (this.type == 'receipt_statement') {
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Number + ':' },
        { 'class': 'fieldTd', 'label': detail['cash_receipt_no'] },
        { 'class': 'labelTd', 'label': this.Date + ':' },
        { 'class': 'fieldTd', 'label': detail['receipt_date'] }]
      };
      this.top_part.push(rowObj);
    }
    else {
      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Receipt_Type + ':' },
        { 'class': 'fieldTd', 'label': (this.type == 'cash_receipt' ? this.Cash_Receipt : this.Payment_Voucher) },
        { 'class': 'labelTd', 'label': this.Number + ':' },
        { 'class': 'fieldTd', 'label': (this.type == 'cash_receipt' ? detail['cash_receipt_no'] : detail['payment_voucher_no']) }]
      };
      this.top_part.push(rowObj);

      rowObj = {
        'col_list': [{ 'class': 'labelTd', 'label': this.Receipt_No + ':' },
        { 'class': 'fieldTd', 'label': (this.type == 'cash_receipt' ? detail['receipt_no'] : detail['voucher_no']) },
        { 'class': 'labelTd', 'label': this.Date + ':' },
        { 'class': 'fieldTd', 'label': (this.type == 'cash_receipt' ? detail['receipt_date'] : detail['voucher_date']) }]
      };
      this.top_part.push(rowObj);
    }

    // { 'class': 'labelTd', 'label': this.Acct_Type + ':' },
    //   { 'class': 'fieldTd', 'label': detail['account_type_name'] }
    rowObj = {
      'col_list': [{ 'class': 'labelTd', 'label': this.Acct + ':' },
      { 'class': 'fieldTd', 'label': acct_name1 },
      { 'class': 'labelTd', 'label': '' },
      { 'class': 'fieldTd', 'label': '' }]
    };
    this.top_part.push(rowObj);

    // rowObj = {
    //   'col_list': [{ 'class': 'labelTd', 'label': 'نوع الحساب:' },
    //   { 'class': 'fieldTd', 'label': detail['account_type_name'] },
    //   { 'class': 'labelTd', 'label': 'إلى حساب' },
    //   { 'class': 'fieldTd', 'label': acct_name }]
    // };
    // this.top_part.push(rowObj);

    rowObj = {
      'col_list': [{ 'class': 'labelTd', 'label': this.Amount + ':' },
      { 'class': 'fieldTd', 'label': detail['paid'] },
      { 'class': 'labelTd', 'label': this.Cost_Center + ':' },
      { 'class': 'fieldTd', 'label': detail['cc_name'] }]
    };
    this.top_part.push(rowObj);

    rowObj = {
      'col_list': [{ 'class': 'labelTd', 'label': this.Pay_Method + ':' },
      { 'class': 'fieldTd', 'label': detail['payment_method_name'] },
      { 'class': 'labelTd', 'label': (this.type != 'payment_voucher' ? this.To : this.From) + ' ' + this.Account + ':' },
      { 'class': 'fieldTd', 'label': acct_name2 }]
    };
    this.top_part.push(rowObj);

    rowObj = {
      'col_list': [{ 'class': 'labelTd', 'label': this.Check_No + ':' },
      { 'class': 'fieldTd', 'label': detail['check_no'] },
      { 'class': 'labelTd', 'label': '' },
      { 'class': 'fieldTd', 'label': '' }]
    };
    this.top_part.push(rowObj);

    this.dp = detail['invoice_list'];
    this.dataSource = new MatTableDataSource(this.dp);
    this.dataSource.sort = this.sort;

  }

  // invoice_list(detail) {
  //   if (detail['account_type'] == 'customer' && this.type == 'cash_receipt') {
  //     let query = "SELECT * FROM `invoice` WHERE `cash_receipt_no` = '" + detail['cash_receipt_no'] + "'";
  //     let obj = { cmd: 'getList', query: query };

  //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //       .subscribe(data => {
  //         this.applicationConstants.appComp.hideBusyCursor();

  //         this.dp = data.data['list'];
  //         data.data['list'].forEach(element => {
  //           element.total = Number(element.total) + Number(element.tax);
  //         });
  //         this.dataSource = new MatTableDataSource(this.dp);
  //         this.dataSource.sort = this.sort;
  //       });
  //   }

  //   else if (detail['account_type'] == 'supplier' && this.type == 'payment_voucher') {
  //     let query = "SELECT * FROM `supplier_invoice` WHERE `payment_voucher_no` = '" + detail['payment_voucher_no'] + "'";
  //     let obj = { cmd: 'getList', query: query };

  //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //       .subscribe(data => {
  //         this.applicationConstants.appComp.hideBusyCursor();

  //         data.data['list'].forEach(element => {
  //           element.invoice_no = element.supplier_invoice_no;
  //           element.invoice_id = element.supplier_invoice_id;
  //           element.total = (Number(element.amount) + Number(element.tax) - Number(element.discount)).toFixed(2);
  //         });
  //         this.dp = data.data['list'];
  //         this.dataSource = new MatTableDataSource(this.dp);
  //         this.dataSource.sort = this.sort;
  //       });
  //   }
  // }

  do(value) {

    //// *************** Print Receipt *************** ////
    if (value == 'print')
      window.open(this.applicationConstants.generatePDF + "?receipt_type=" + this.type + "&receipt_no=" + 
        this.no + "&lang=" + this.applicationConstants.user_lang, "_blank");

    //// *************** Delete Receipt *************** ////
    else if (value == 'delete') {
      if (confirm(this.Del_Msg)) {
        let values;

        if (this.type = 'payment_voucher') {
          values = [{ 'table_name': 'payment_voucher', 'payment_voucher_no': this.no }];
          values.push({ 'table_name': 'payment_voucher_acct', 'payment_voucher_no': this.no });
          values.push({ 'table_name': 'payment_voucher_invoice', 'payment_voucher_no': this.no });
        }
        else {
          values = [{ 'table_name': 'cash_receipt', 'cash_receipt_no': this.no }];
          values.push({ 'table_name': 'cash_receipt_acct', 'cash_receipt_no': this.no });
          values.push({ 'table_name': 'cash_receipt_invoice', 'cash_receipt_no': this.no });
        }

        let obj = { cmd: 'deleteRec', values: values };
        console.log(values);
        this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
          .subscribe(data => {
            this.applicationConstants.appComp.hideBusyCursor();
            if (data.status['type'] == 'success') {
              alert(this.Success_Msg);
              this.router.navigate(['sub_menu/3/receipt_list']);
            }
            else {
              alert(this.Error_Msg);
            }
          });
      }
    }
  }
}
